<script>
import Modal from '@/components/Modal'
import ButtonRow from '@/components/ButtonRow'

export default {
    components: {Modal, ButtonRow},
    emits: ['updated', 'close'],
    data() {
        return {
            isCloseable: true,
        }
    },
    watch: {
        isCloseable() {
            this.$store.dispatch('SET_CLOSEABLE', this.isCloseable)
        },
    },
    methods: {
        open() {
            if (this.$refs.modal && this.$refs.modal.open) {
                this.$refs.modal.open()
            }

            if (this.reset) {
                this.reset()
            }
        },
        close(forceClose = false) {
            if (forceClose) {
                this.isCloseable = true
            }

            this.$nextTick(() => {
                if (this.$refs.modal) {
                    this.$refs.modal.close()
                }
            })
        },
        scrollBottom() {
            this.$refs.modal.scrollBottom()
        },
    },
}
</script>
